var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-layout"},[_c('div',{staticClass:"site-layout-header sticky"},[_c('site-header')],1),_c('div',{staticClass:"site-main main-padding"},[_c('site-app-main')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }